import { Controller } from "@hotwired/stimulus"

// Menu a comparsa dell'intestazione (account e campanella): apre e chiude i target "panel"
// (sfondo che chiude al clic, il menu, l'icona X); si chiude anche con Esc e prima che Turbo salvi la pagina
// in cache, così tornando indietro il menu è chiuso (Layout.js lo chiude a ogni cambio di pagina).
export default class extends Controller {
  static targets = ["panel", "button"]

  connect() {
    this.onKey = this.onKey.bind(this)
    this.close = this.close.bind(this)
    document.addEventListener("turbo:before-cache", this.close)
  }

  disconnect() {
    document.removeEventListener("keydown", this.onKey)
    document.removeEventListener("turbo:before-cache", this.close)
  }

  toggle() { this.isOpen ? this.close() : this.open() }

  open() { this.set(true); document.addEventListener("keydown", this.onKey) }

  close() { this.set(false); document.removeEventListener("keydown", this.onKey) }

  onKey(event) { if (event.key === "Escape") this.close() }

  get isOpen() { return this.panelTargets.some((p) => !p.hidden) }

  set(open) {
    this.panelTargets.forEach((p) => (p.hidden = !open))
    this.buttonTargets.forEach((b) => b.setAttribute("aria-expanded", String(open)))
  }
}
